export default __webpack_public_path__ + "static/media/CV_DIGITAL.3732d359.pdf";